var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriorityLow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#29D2DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8241 20.7471H17.6784C17.2243 20.7471 16.8456 20.3999 16.8063 19.9475L16.0981 11.8032C16.0391 11.125 16.4003 10.4796 17.0091 10.1752C17.4763 9.9416 18.0262 9.9416 18.4933 10.1752C19.1022 10.4796 19.4634 11.125 19.4044 11.8032L18.6962 19.9475C18.6569 20.3999 18.2782 20.7471 17.8241 20.7471Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5017 24.2494C19.5017 25.2164 18.7179 26.0003 17.7509 26.0003C16.7839 26.0003 16 25.2164 16 24.2494C16 23.2824 16.7839 22.4985 17.7509 22.4985C18.7179 22.4985 19.5017 23.2824 19.5017 24.2494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityLow);
export default __webpack_public_path__ + "static/media/priority-low.414395a6ac8a55e3e2cbd3be42f72ff2.svg";
export { ForwardRef as ReactComponent };